import { translateFn } from '../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { EncryptionExclusionItem, EncryptionExclusionItemType } from '@nirvana/shared/dtos/types/policies/common';

// maximum entity length
export const MAX_ENTITY_LENGTH = 260;

// validate volume id (GUID)
export function validateVolumeId(entity: string): ValidationResult {
  const volumeIdRegex = /^\\{2}\?\\Volume\{[a-zA-Z0-9-]+\}\\$/;
  if (!volumeIdRegex.test(entity)) {
    return {
      valid: false,
      error: translateFn('Invalid GUID'),
    };
  }

  return { valid: true };
}

// validate mount point (drive letter)
export function validateMountPoint(entity: string): ValidationResult {
  const mountPointRegex = /^[A-Z]:$/;
  if (!mountPointRegex.test(entity)) {
    return {
      valid: false,
      error: translateFn('Invalid drive letter'),
    };
  }

  return { valid: true };
}

// validate entity by type
export function validateEntityByType(type: EncryptionExclusionItemType, entity: string): ValidationResult {
  switch (type) {
    case EncryptionExclusionItemType.MOUNT_POINT:
      return validateMountPoint(entity);
    case EncryptionExclusionItemType.VOLUME_ID:
      return validateVolumeId(entity);
    default:
      return { valid: true };
  }
}

// validate duplicates
export function validateDuplicates(
  exclusionItem: EncryptionExclusionItem,
  exclusionsInGrid: EncryptionExclusionItem[]
): ValidationResult {
  const exclusionEntity = exclusionItem.entity.toLowerCase();
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: EncryptionExclusionItem) =>
      exclusionInGrid.type === exclusionItem.type && exclusionInGrid.entity.toLowerCase() === exclusionEntity
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
